import axios from "axios";

// Same-origin by default (nginx proxies /api/* on whatever host served the page —
// IP, this domain, or any future one — with zero CORS involved). Only set
// REACT_APP_BACKEND_URL when the frontend and backend run on different
// hosts/ports, e.g. local dev (CRA dev server on :3000, uvicorn on :8001).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token if present (fallback when cookies are blocked)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nf_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
